import { getDeptList } from "@/apis/dept.api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

// 获取部门列表
export function useDeptList(deptName: string) {
  const { data: res } = useQuery({
    queryKey: ["deptList", deptName],
    queryFn: () => getDeptList(deptName),
    enabled: !!deptName,
  });

  return useMemo(() => {
    return {
      list: res?.data.data || [],
    };
  }, [res]);
}
